import GA from './GA';

export default class GAController {
    private static readonly secondChunk: number = 2;

    private static readonly firstChunk: number = 1;

    static init(url: string[]) {
        switch (url[GAController.firstChunk]) {
            case '': {
                GA.indexPageScrollHandler();
                break;
            }
            default: {
            }
        }
    }
}
